import React from 'react';
require('./AccLoading.scss');

export default class AccLoading extends React.Component {
  constructor(...args) {
    super(...args);
  }

  componentDidMount() {
    this.props.getWidgetHtmlHeight && this.props.getWidgetHtmlHeight();
  }

  render() {
    return (<div className="acc-loading-container" >
              <div className="acc-loading"></div>
              <i className="light"></i>
           </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailPage/AccLoading/AccLoading.js